import React,{ useEffect } from 'react';
import Slider from './Slider';
import AllProjects from './AllProjects';
import NewCard from './NewCard';

const SalesServices: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <div>
      <Slider />
      <NewCard/>
      {/* <AllProjects /> */}
    </div>
  );
};

export default SalesServices;
